export const reLogin = /^((\/login\/?)|(\/ref\/))/;
